var React = require('react');

function InStockIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.96666667 17.3 9.63333333-9.63333333-1.4333333-1.43333334-8.20000003 8.19999997-3.96666667-3.9666666-1.43333333 1.4333333zm-7.96666667 6.7c-.53333333 0-1-.2-1.4-.6s-.6-.8666667-.6-1.4v-20c0-.53333333.2-1 .6-1.4s.86666667-.6 1.4-.6h20c.5333333 0 1 .2 1.4.6s.6.86666667.6 1.4v20c0 .5333333-.2 1-.6 1.4s-.8666667.6-1.4.6zm0-2h20v-20h-20zm.03333333-20v20z","fill":"#058267"}));
}

InStockIcon.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = InStockIcon;

InStockIcon.default = InStockIcon;
